export default __webpack_public_path__ + "42fbbc79ec4779743edebab928b3c675.png";